import { Link } from 'react-router-dom';
import logo from "../../../studentassets/logo.png";
import icon01 from "../../../studentassets/images/icons/01.svg";
import icon02 from "../../../studentassets/images/icons/02.svg";
import icon03 from "../../../studentassets/images/icons/free.png";
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, selectMode, toggleSideBar } from '../../../service/slice/ThemeSlice';
import { MdOutlineLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import { useState } from 'react';

export default function Header() {

    const [leftSideToggle, setLeftSideToggle] = useState(false);

    const theme = useSelector(selectMode);
    const dispatch = useDispatch();
    const userSubscription = useSelector((state)=> state?.userSlice?.userSubscription)
    const userDetails = useSelector((state)=> state?.userSlice?.value)

    return (
        <>
            <div className="header-area-one" style={{ background: theme === 'light' ? '#fff' : '#151A24', color: theme === 'light' ? '#000' : '#fff' }}>
                <div className="container-30">
                    <div className="col-lg-12">
                        <div className="header-inner-one">
                            <div className="left-logo-area">
                                <Link to="/" className="logo">
                                    {
                                        theme === "dark" ?
                                            (
                                                <img src={logo} alt="logo" style={{ height: "70px" }} />
                                            ) : (
                                                <img src={logo} alt="logo" style={{ height: "70px" }} />
                                            )
                                    }

                                </Link>
                                <button className="left-side-open-clouse" id="collups-left" onClick={()=>{dispatch(toggleSideBar())}}>
                                    <img src={icon01} alt="icons" style={{ color: theme === 'light' ? '#000' : '#fff' }} />
                                </button>
                            </div>
                            <div className="header-right">
                                <div className="chip grade">
                                    Grade: {!userDetails? '' : userDetails?.grade ? userDetails?.grade: '6-8'}
                                </div>
                                <div className="button-area">
                                    {userSubscription ? 
                                    <Link to="/user/packagehistory" className="rts-btn btn-primary">
                                        <img src={icon02} alt="icons" />
                                        {userSubscription?.name}
                                    </Link>
                                    :
                                    <Link to="/user/packagehistory" className="rts-btn btn-primary">
                                        <img src={icon03} alt="icons" style={{height: "30px"}} />
                                        upgrade now
                                    </Link>}
                                </div>



                                <div style={{ display: "flex", justifyContent: "center", marginBottom: "5px" }}>
                                    <button className="theme-toggle-btn" onClick={() => dispatch(toggleMode())} >
                                        {theme === "light" ? <MdOutlineLightMode /> : <MdOutlineDarkMode style={{ color: theme === 'light' ? '#000' : '#fff' }} />}
                                    </button>
                                </div>


                                {/* <ThemeToggle /> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
